import * as React from 'react';
import { FormControlLabel } from '../../../../../components/material-ui/FormControlLabel';
import { Switch } from '../../../../../components/material-ui/Switch';
import { checkInputTimeSupport } from '../../../../../service/DateTimeUtils';

const AlertSwitcher = ({ checked, switcherType, toggleHandler, label }) => {
    const handleToggle = React.useCallback(() => {
        toggleHandler(switcherType);
    }, [switcherType]);

    return (
        <FormControlLabel
            control={<Switch checked={checked} onChange={handleToggle} disabled={!checkInputTimeSupport} color="primary" />}
            label={label}
        />
    );
};

export { AlertSwitcher };
